import { Component } from '@angular/core';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: '[app-value]',
    templateUrl: './value.component.html',
    styleUrls: ['./value.component.scss'],
    standalone: true
})
export class ValueComponent {
}
